import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, Radio, TreeSelect } from 'antd'
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores, SelectPayItem } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import { CheckImgs } from "../../component/common/Imgs"
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 }
}

type fetchParams = {
  customer_name: string | undefined,
  contact_way: string | undefined,
  channel_id: string | undefined,
  init_sales_name: string | undefined,
  follow_sales_name: string | undefined,

  deal_store_id: string[] | undefined
  deal_sales_name: string | undefined,
  mix_agreement_amount: number | undefined,
  max_agreement_amount: number | undefined,

  deal_item_id: string | undefined,
  min_item_days: number | undefined,
  max_item_days: number | undefined,
  min_gift_days: number | undefined,
  max_gift_days: number | undefined,

  pay_item: undefined,
  pay_way: undefined,
  review_status: undefined,
  date: any
}

type pagination = {
  current: number,
  pageSize: number,
  total: number,
  showSizeChanger: boolean
}

type fromItem = {
  id: string,
  channel_name: string
}

type project = {
  id: string
  item_name: string
}

type changeRecord = {
  update_user_name: string
  update_time: string
  change_user_name: string
  change_pay_code: string
  change_pay_date: string
}

export default function () {

  let fetchOtherParamsTmpl: fetchParams = {
    customer_name: undefined,
    contact_way: undefined,
    channel_id: undefined,
    init_sales_name: undefined,
    follow_sales_name: undefined,

    deal_store_id: undefined,
    deal_sales_name: undefined,
    mix_agreement_amount: undefined,
    max_agreement_amount: undefined,

    deal_item_id: undefined,
    min_item_days: undefined,
    max_item_days: undefined,
    min_gift_days: undefined,
    max_gift_days: undefined,

    pay_item: undefined,
    pay_way: undefined,
    review_status: undefined,
    date: null
  }

  const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string, pay_date?: string, pay_code?: string } | undefined>()
  const [form] = Form.useForm()
  const [urls, setUrls] = useState<string[]>([])
  const [changeRecordForm] = Form.useForm()

  const [swiperVisible, setSiperVisible] = useState<boolean>(false)
  const [confrimMoneyVisible, setConfrimMoneyVisible] = useState<boolean>(false)
  const [changeRecordVisible, setChangeRecordVisible] = useState<boolean>(false)

  const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
  const [pagination, setPagination] = useState<pagination>({
    current: 1,
    pageSize: 8,
    total: 0,
    showSizeChanger: true
  })

  const [initDate, setInitDate] = useState<boolean>(true)

  const [data, setData] = useState<any>([])
  const [data2, setData2] = useState<any>([])
  const [passType, setPassType] = useState<number | undefined>(undefined)

  const [fromItemData, setFromItemData] = useState<fromItem[]>([])
  const [selectNameData, setSelectNameData] = useState<project[]>([])
  const [changeData, setChangeData] = useState<changeRecord[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    if (initDate) {
      var startDate = moment().startOf('month');
      var endDate = moment().endOf('month');
      // 初始化付款日期
      fetchOtherParams.date = [startDate, endDate];

      setInitDate(false)
    }

    fetch({ pagination, fetchOtherParams })
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    // 查询来源渠道列表
    baseAxiosNoInfo('/finance_center/global/channel_source_list').then((res: any) => {
      res && setFromItemData(res)
    })

    // 查询套餐项目
    baseAxiosNoInfo('/global/item_list', { params: { item_type: 3 } }).then((res: any) => {
      res && setSelectNameData(res)
    })
  }, [])

  const handleChange = (value: any, attr: string) => {
    let params: any = _.cloneDeep(fetchOtherParams)
    params[attr] = value

    setFetchOtherParams(params)
  }

  const handleSearch = () => {
    const p = { ...pagination }
    p.current = 1

    fetch({ pagination: p, fetchOtherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current
    p.pageSize = antPagination.pageSize

    setPagination(p)
  }

  const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
    setLoading(true)

    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...fetchOtherParams }

    if (params.date) {
      params.start_pay_date = params.date[0].format('YYYY-MM-DD')
      params.end_pay_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    if (params.deal_store_id) {
      params.deal_store_id = params.deal_store_id.join(',')
    }

    if (params.pay_item) {
      params.pay_item = params.pay_item.join(',')
    }

    axiosTable.get('/finance_center/yuesao/pay_records/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setData(response.records)
        setData2([response.yuesao_pay_summary])
      }

      setLoading(false)
    })
  }

  const resetForm = () => {
    setInitDate(false)
    setFetchOtherParams(fetchOtherParamsTmpl)

    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total
    delete iPagination.showSizeChanger

    let params: any = { ...fetchOtherParams }

    if (params.date) {
      params.start_pay_date = params.date[0].format('YYYY-MM-DD')
      params.end_pay_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    if (params.deal_store_id) {
      params.deal_store_id = params.deal_store_id.join(',')
    }

    if (params.pay_item) {
      params.pay_item = params.pay_item.join(',')
    }

    baseAxiosComplete('/finance_center/yuesao/pay_records/excel', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  const recursionChildren = (children: any[]) => {
    let childArr: any = []

    children.forEach((el: any) => {
      childArr.push({
        title: el.channel_name,
        value: el.id,
        key: el.id,
        children: el.children && recursionChildren(el.children)
      })
    })

    return childArr
  }

  // 审核
  const onFinish = (value: any) => {
    baseAxiosComplete.post('/finance_center/yuesao/pay_records/review', {
      pay_id: activeRecord?.id,
      review_status: value.review_status,
      review_refuse_reason: value.review_refuse_reason,
      remark: value.remark

    }).then((res: any) => {
      if (res.status === 0) {
        fetch({ pagination, fetchOtherParams })
        setConfrimMoneyVisible(false)
      }
    })
  }

  const onChangeRecordFinish = (value: any) => {
    baseAxiosComplete.post('/finance_center/pay_records/update_submit', {
      pay_id: activeRecord?.id,
      user_name: value.user_name,
      pay_date: value.pay_date.format('YYYY-MM-DD'),
      pay_code: value.pay_code

    }).then((res: any) => {
      if (res.status === 0) {
        setChangeRecordVisible(false)

        baseAxiosNoInfo('/finance_center/pay_records/update_records', {
          params: {
            pay_id: activeRecord?.id
          }

        }).then((res: any) => {
          res && setChangeData(res)
        })
      }
    })
  }

  const handlePassChange = (e: RadioChangeEvent) => {
    setPassType(e.target.value)
  }

  let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

  return (<div className="common-page">
    {/* 财务中心 -> 财务管理 -> 月嫂收款管理 */}
    <BreadCrumb position={['财务中心', '月嫂收款管理']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores multiple showSearch placeholder="签单门店" value={fetchOtherParams.deal_store_id} onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }} />
        </div>

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_way') }} value={fetchOtherParams.contact_way} />
        <TreeSelect allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 160 }} value={fetchOtherParams.channel_id} virtual={false} treeData={recursionChildren(fromItemData)} placeholder="来源渠道" onChange={(v: any) => {
          handleChange(v, 'channel_id')
        }}
        />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="初始销售" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'init_sales_name') }} value={fetchOtherParams.init_sales_name} />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="跟进销售" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'follow_sales_name') }} value={fetchOtherParams.follow_sales_name} />

        <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectPayItem multiple showSearch value={fetchOtherParams.pay_item} onChange={(v: string[]) => { handleChange(v, 'pay_item') }} />
        </div>

        <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="收款方式" value={fetchOtherParams.pay_way} onChange={(v: number) => { handleChange(v, 'pay_way') }}>
          <Option key={1} value={1}>现金</Option>
          <Option key={2} value={2}>支付宝</Option>
          <Option key={3} value={3}>微信</Option>
          <Option key={4} value={4}>银联卡</Option>
          <Option key={5} value={5}>押金抵扣</Option>
          <Option key={6} value={6}>小精灵</Option>
          <Option key={7} value={7}>对公转账</Option>
          <Option key={8} value={8}>抵扣券</Option>
        </Select>
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="收款人" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'deal_sales_name') }} value={fetchOtherParams.deal_sales_name} />

        <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核结果" value={fetchOtherParams.review_status} onChange={(v: number) => { handleChange(v, 'review_status') }}>
          <Option value={0} key={0}>待审核</Option>
          <Option value={1} key={1}>审核通过</Option>
          <Option value={2} key={2}>审核不通过</Option>
        </Select>

        <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["付款开始日期", "付款结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
        <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 180 }} placeholder="签单套餐" value={fetchOtherParams.deal_item_id} onChange={(v: string) => { handleChange(v, 'deal_item_id') }}>
          {ItemNameOptions}
        </Select>
        <div className="range-form-item fl" style={{ marginRight: 8, marginBottom: 12 }} >
          <Input onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'mix_agreement_amount') }} value={fetchOtherParams.mix_agreement_amount} style={{ width: 130 }} placeholder="合同金额最小值" />
          <span style={{ margin: '0 4px' }}>-</span>
          <Input onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'max_agreement_amount') }} value={fetchOtherParams.max_agreement_amount} style={{ width: 130 }} placeholder="合同金额最大值" />
        </div>
      </Space>

      <div style={{ marginTop: 10 }}>
        <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
      </div>
    </div>

    <div className="common-main">
      <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="pay_id" pagination={pagination} onChange={handleTableChange}>
        <Column fixed title="客户姓名" dataIndex="customer_name" key="customer_name" />
        <Column fixed title="联系方式" dataIndex="contact_way" key="contact_way" />
        <Column fixed title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />

        <Column title="套餐名称" dataIndex="deal_item_name" key="deal_item_name" />
        <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
        <Column title="已收总金额" width={75} dataIndex="total_pay_amount" key="total_pay_amount" />
        <Column title="已核总金额" width={75} dataIndex="total_review_amount" key="total_review_amount" />

        <Column title="套餐天数" width={65} dataIndex="item_days" key="item_days" />
        <Column title="公休日费用" width={75} dataIndex="public_holiday_cost" key="public_holiday_cost" />
        <Column title="节假日费用" width={75} dataIndex="legal_holiday_cost" key="legal_holiday_cost" />
        <Column title="合同凭证" dataIndex="deal_prov_pic_list" key="deal_prov_pic_list" render={(v: any) => {
          return <Button onClick={() => {
            setUrls(v)
            setSiperVisible(true)
          }} size="small" >查看</Button>
        }} />

        <Column title="收款项目" dataIndex="pay_item" key="pay_item" />
        <Column title="收款单号" dataIndex="pay_code" key="pay_code" />
        <Column title="收款凭证" dataIndex="pay_prov_pic_list" key="pay_prov_pic_list" render={(v: any) => {
          return <Button onClick={() => {
            setUrls(v)
            setSiperVisible(true)
          }} size="small" >查看</Button>
        }} />
        <Column title="收款方式" dataIndex="pay_way" key="pay_item" />
        <Column title="收款金额" dataIndex="pay_amount" key="pay_amount" />
        <Column title="收款日期" dataIndex="pay_date" key="pay_date" />
        <Column title="来源渠道" dataIndex="channel_name" key="channel_name" />
        <Column title="初始销售" dataIndex="init_sales_name" key="init_sales_name" />
        <Column title="跟进销售" dataIndex="follow_sales_name" key="follow_sales_name" />
        <Column title="收款人" dataIndex="deal_sales_name" key="deal_sales_name" />
        <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
        <Column title="备注" dataIndex="pay_remark" key="pay_remark" />

        <Column
          title="操作"
          key="action"
          render={(text, record: any) => {
            return (<Space size="middle">
              {record.review_status === 0 && permission.includes('审核') && <Button onClick={() => {
                form.setFieldsValue({
                  review_status: undefined,
                  review_refuse_reason: undefined,
                })

                setPassType(undefined)

                baseAxiosNoInfo('/finance_center/pay_records/update_records', {
                  params: {
                    pay_id: record.pay_id
                  }

                }).then((res: any) => {
                  res && setChangeData(res)
                })

                setConfrimMoneyVisible(true)

                setActiveRecord({ id: record.pay_id, pay_code: record.pay_code, pay_date: record.pay_date, user_name: record.customer_name })
              }} size="small" >审核</Button>}
            </Space>)
          }}
        />
      </Table>
    </div>

    <div className="common-main">
      <h3>汇总</h3>

      <Table loading={loading} dataSource={data2} scroll={{ x: 'max-content' }} bordered={true} >
        <Column title="签单数" dataIndex="deal_num" key="deal_num" />
        <Column title="套餐总天数" dataIndex="item_days" key="item_days" />
        <Column title="合同总金额" dataIndex="agreement_amount" key="agreement_amount" />
        <Column title="收款总金额" dataIndex="pay_amount" key="pay_amount" />
      </Table>
    </div>

    {/* 审核弹窗 */}
    <Modal title="收款审核" visible={confrimMoneyVisible} footer={false} onCancel={() => { setConfrimMoneyVisible(false) }} width={800}>
      <Button style={{ marginBottom: 8 }} size="middle" type="primary" onClick={() => {
        changeRecordForm.setFieldsValue({
          user_name: activeRecord?.user_name, pay_code: activeRecord?.pay_code,
          pay_date: moment(activeRecord?.pay_date)
        })

        setChangeRecordVisible(true)
      }}>修改</Button>

      {/* 修改记录 */}
      <Table pagination={false} dataSource={changeData} scroll={{ x: 'max-content' }} bordered={true} rowKey="id">
        <Column title="修改人" dataIndex="update_user_name" key="update_user_name" />
        <Column title="修改时间" dataIndex="update_time" key="update_time" />
        <Column title="客户姓名" dataIndex="change_user_name" key="change_user_name" />
        <Column title="付款单号" dataIndex="change_pay_code" key="change_pay_code" />
        <Column title="付款日期" dataIndex="change_pay_date" key="change_pay_date" />
      </Table>

      <Form form={form} onFinish={onFinish} >
        <Form.Item style={{ marginTop: 8, marginBottom: 8 }} label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
          <Radio.Group onChange={handlePassChange} value={passType}>
            <Radio value={1}>通过</Radio>
            <Radio value={2}>不通过</Radio>
          </Radio.Group>
        </Form.Item>

        {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
          <Input />
        </Form.Item>}

        {passType === 1 && <Form.Item label="备注" name="remark">
          <Input />
        </Form.Item>}

        <Form.Item wrapperCol={{ span: 12, offset: 0 }}>
          <Button type="primary" htmlType="submit">提交审核</Button>
        </Form.Item>
      </Form>
    </Modal>

    {/* 修改记录弹窗 */}
    <Modal title="修改记录" visible={changeRecordVisible} footer={false} onCancel={() => { setChangeRecordVisible(false) }} width={500}>
      <Form {...formItemLayout} form={changeRecordForm} onFinish={onChangeRecordFinish} >
        <Form.Item label="修改后的客户姓名" name="user_name" rules={[{ required: true, message: '必须填写修改后的客户姓名' }]}>
          <Input />
        </Form.Item>

        <Form.Item label="修改后的付款单号" name="pay_code" rules={[{ required: true, message: '必须填写修改后的付款单号' }]}>
          <Input />
        </Form.Item>

        <Form.Item required label="修改后的付款日期" name="pay_date" rules={[{ required: true, message: '必须选择修改后的付款日期' }]} >
          <DatePicker placeholder="" />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 8 }}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>

    <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
  </div>)
}